import dictionary from './dictionary.json';
const config = {
    resource: 'next-wishlist',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map